module.exports = __webpack_public_path__ + "01471aaaf11d4ea0fb426fdc3e0547d9.svg";